import type { WidgetPreset } from "../types";
import templateHtml from "./template.html?raw";

export const PLOT_TWIST: WidgetPreset = {
  id: "plot-twist",
  label: "Plot Twist 🌀",
  defaultWidth: 210,
  defaultHeight: 50,
  html: templateHtml,
};
